import styles from './Collapse.module.css';
import { IconArrowDown, IconArrowRight } from '@axafr-btc-ds/icons';
import { Link } from '@axafr-btc-ds/link';
import { CollapseProps } from './Collapse.interface';
import { ColorHex } from '@axafr-btc-ds/colors';
import classNames from 'classnames';
import { useState } from 'react';

export const Collapse = ({
    expanded,
    title,
    children,
    className,
    titleClassName,
    onClick,
}: CollapseProps): JSX.Element => {
    const [ innerExpanded, setInnerExpanded ] = useState(false);

    const canExpand = innerExpanded || expanded;

    const handleClick = () => {
        if (expanded !== undefined) {
            onClick?.();
        } else {
            setInnerExpanded(value => !value);
        }
    };
    return (
        <div className={ className }>
            <Link
                className={ classNames(styles.collapse, titleClassName) }
                onClick={ handleClick }
            >
                { canExpand ? (
                    <IconArrowDown className={ styles.collapseIcon } color={ ColorHex.axablue } />
                ) : (
                    <IconArrowRight className={ styles.collapseIcon } color={ ColorHex.axablue } />
                ) }
                <span className={ styles.collapseText }>{ title }</span>
            </Link>
            { canExpand && <div>{ children }</div> }
        </div>
    );
};
